module.exports = __webpack_public_path__ + "static/media/spicy-piri-piri-mb-en.b7974911.jpg";